// Shared by the submission list and the submission / series review pages.
export const plural = (n, word) => `${n} ${word}${n === 1 ? "" : "s"}`;

export const qcTone = (s) =>
  s === "Approved" ? "success" : s === "Rejected" ? "danger" : "pending";

export const fmtDate = (v) => {
  if (!v) return "—";
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};
